import HeadquartersBuildingIcon from './HeadquartersBuildingIcon'

export default HeadquartersBuildingIcon
